import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TourIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TourIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.6404 9.02252V11.9019C26.6368 11.8995 26.6327 11.8969 26.6282 11.8941C26.2886 11.6776 23.6635 10.0041 20.0332 10.0041C16.4305 10.0041 13.4984 11.8563 13.3798 11.9322C15.0112 12.7566 17.3687 13.6375 19.9833 13.6375C24.2439 13.6375 27.8221 11.2981 28.6875 10.6764C28.8373 10.5782 29.0037 10.5292 29.1702 10.5292C30.5349 10.5292 31.6333 11.6089 31.6333 12.9504L31.6666 30.9121C31.6666 32.2536 30.5682 33.3334 29.2034 33.3334C29.0204 33.3334 28.8539 33.2843 28.7208 33.1861C27.8554 32.5644 24.2771 30.225 20.0166 30.225C15.756 30.225 12.1778 32.5644 11.3123 33.1861C11.1625 33.2843 10.9961 33.3334 10.8297 33.3334C9.46497 33.3334 8.36654 32.2536 8.36654 30.9121L8.33325 12.9504C8.33325 11.6089 9.43168 10.5292 10.7964 10.5292C10.9795 10.5292 11.1459 10.5782 11.279 10.6764C11.6075 10.9124 12.3269 11.3959 13.3261 11.905V9.02252C13.3261 7.73008 14.3913 6.66669 15.7227 6.66669H24.2439C25.5586 6.66669 26.6404 7.71372 26.6404 9.02252Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      {isGradient && (
        <defs>
          <linearGradient
            id={gradientId}
            x1="8.33325"
            y1="22.4638"
            x2="31.6666"
            y2="22.4638"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={from} />
            <stop offset="1" stopColor={to} />
          </linearGradient>
        </defs>
      )}
    </svg>
  );
};

export default TourIcon;
